import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import State from 'store/State';

export interface SymbolStaticDataState {
    assetClasses: string[];
    countries: string[];
    currencyCodes: string[];
    regions: string[];
    industries: string[];
    sectors: string[];
    subIndustries: string[];
    superSectors: string[];
    secTypes: string[];
}

export const initialSymbolStaticData: SymbolStaticDataState = {
    assetClasses: [],
    countries: [],
    currencyCodes: [],
    regions: [],
    industries: [],
    sectors: [],
    subIndustries: [],
    superSectors: [],
    secTypes: [],
};

const symbolStaticDataSlice = createSlice({
    name: 'symbolStaticDataSlice',
    initialState: initialSymbolStaticData,
    reducers: {
        set: (state, action: PayloadAction<SymbolStaticDataState>) => {
            return action.payload;
        },
    },
});

export const selectSymbolStaticDataState = (state: State) =>
    state.symbolStaticData;

export const { set: setSymbolStaticData } = symbolStaticDataSlice.actions;

export default symbolStaticDataSlice.reducer;
